import { WbsItemStatus } from '../../../domain/entity/WbsItemEntity'
import { getWbsItemStatusLabel } from '../../../lib/functions/wbsItem'
import { colorPalette } from '../../style/colorPalette'
import { StatusChip } from '../../components/data-display/StatusChip'

// TODO
// Possibility to keep color in DB in the future
// 配色は StatusComboBox からも参照されるため、ここを単一ソースとして維持する。
export const getOptionStyles = (value: string) => {
  switch (value) {
    case WbsItemStatus.TODO:
      return {
        backgroundColor: `${colorPalette.monotone[1]}`,
        textColor: `${colorPalette.monotone[4]}`,
        borderColor: `1px solid ${colorPalette.monotone[2]}`,
      }
    case WbsItemStatus.DOING:
      return {
        backgroundColor: `${colorPalette.yellow[1]}`,
        textColor: `${colorPalette.yellow[4]}`,
        borderColor: `1px solid ${colorPalette.yellow[2]}`,
      }
    case WbsItemStatus.REVIEW:
      return {
        backgroundColor: `${colorPalette.green[1]}`,
        textColor: `${colorPalette.green[7]}`,
        borderColor: `1px solid ${colorPalette.green[2]}`,
      }
    case WbsItemStatus.DONE:
      return {
        backgroundColor: `${colorPalette.skyBlue[1]}`,
        textColor: `${colorPalette.skyBlue[7]}`,
        borderColor: `1px solid ${colorPalette.skyBlue[2]}`,
      }
    case WbsItemStatus.DISCARD:
      return {
        backgroundColor: `${colorPalette.monotone[3]}`,
        textColor: `${colorPalette.monotone[0]}`,
        borderColor: `1px solid ${colorPalette.monotone[3]}`,
      }
    default:
      return {
        backgroundColor: `${colorPalette.monotone[0]}`,
        textColor: `${colorPalette.monotone[10]}`,
        borderColor: `${colorPalette.monotone[10]}`,
      }
  }
}

type WbsItemStatusChipProps = {
  status: WbsItemStatus
  /** 文字数に応じて幅を最適化する（既定 false: 最小幅 77px） */
  fitContent?: boolean
}

// WBSアイテムのステータス（TODO/DOING/REVIEW/DONE/DISCARD）を共通チップで表示する。
export const WbsItemStatusChip = ({
  status,
  fitContent,
}: WbsItemStatusChipProps) => {
  const { backgroundColor, textColor, borderColor } = getOptionStyles(status)
  return (
    <StatusChip
      label={getWbsItemStatusLabel(status) ?? status}
      backgroundColor={backgroundColor}
      textColor={textColor}
      borderColor={borderColor}
      fitContent={fitContent}
    />
  )
}
